"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";

/**
 * Custom 404 page for static export.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
      <p className="text-gray-500 text-sm text-center mb-6">
        Page not found
      </p>
      <Link href="/" prefetch={true}>
        <Button>Go Home</Button>
      </Link>
    </div>
  );
}
